import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-alert-triangle"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><g transform=\"translate(5589.29 376.702)\" class=\"\"><line x1=\"-5567.3\" x2=\"-5567.3\" y1=\"-357.5\" y2=\"-353.5\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"-5567.3\" x2=\"-5567.3\" y1=\"-349.5\" y2=\"-349.5\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line></g><path d=\"M22,31h-8.2c-1.5,0-2.5-1.7-1.7-3l4.1-7.1l4.1-7.1c0.8-1.3,2.7-1.3,3.5,0l4.1,7.1l4.1,7.1c0.8,1.3-0.2,3-1.7,3\n\t\tH22z\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path></g>", 1)
  ]), 16))
}
export default { render: render }